import { render, staticRenderFns } from "./ChangedDocuments.vue?vue&type=template&id=6189b54f&"
import script from "./ChangedDocuments.vue?vue&type=script&lang=js&"
export * from "./ChangedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports